import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

export function EmptyRoutes() {
  return (
    <CenteredLayout>
      <div>
        <h2 className="h3 mb-16">You don’t have any routes set up</h2>
        <p className="p-lt">
          Routes allow unencrypted access between your Managed Nebula network and devices which are not able to run the
          Managed Nebula client software (dnclient).
        </p>
        <ul className="ul-lt">
          <li>A route may have one or more IP ranges (routable CIDRs) which you would like to access.</li>
          <li>
            A host, lighthouse, or relay will act as a router between your Managed Nebula network and those external IP
            addresses.
          </li>
          <li>
            Tags are used to subscribe hosts, lighthouses, and relays to routes, giving them access to the external
            resources.
          </li>
        </ul>
        <p className="p-lt mb-24">
          To learn more about routes, read our guide on how to{' '}
          <a
            className="a inline"
            href="https://www.defined.net/docs/guides/extend-access-beyond-overlay-hosts/"
            target="_blank"
            rel="help"
          >
            extend network access beyond overlay hosts
          </a>
          .
        </p>
        <LinkButton to="add">Add route</LinkButton>
      </div>
    </CenteredLayout>
  );
}
